export const NAME = 'prompts';
export const EMPTY_PROMPT_ID = -1;
export const PROMPT_LIST_OPTIONS = [
  'Question',
  'Summary',
  'Suggestion',
  'Student',
];
